import { __read } from "tslib";
import React, { useState, useRef } from 'react';
import { Tooltip } from '@hose/eui';
import { FilledOtherTranslate, FilledTipsClose, FilledTipsYes } from '@hose/eui-icons';
import { Fetch } from '@ekuaibao/fetch';
export var TranslatorBubble = function (_a) {
    var translateConfig = _a.translateConfig, onBubbleClose = _a.onBubbleClose, target = _a.target;
    var _b = __read(useState(true), 2), visible = _b[0], setVisible = _b[1];
    var _c = __read(useState(false), 2), enable = _c[0], setEnable = _c[1];
    var _d = __read(useState(false), 2), isDragging = _d[0], setIsDragging = _d[1];
    var _e = __read(useState({ x: 20, y: 120 }), 2), position = _e[0], setPosition = _e[1];
    var _f = __read(useState(false), 2), tooltipVisible = _f[0], setTooltipVisible = _f[1];
    var ref = useRef(null);
    var handleMouseDown = function (e) {
        var _a;
        setIsDragging(true);
        var isFloatingDragging = true;
        e.preventDefault();
        e.stopPropagation();
        var rect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var offsetX = e.clientX - rect.left;
        var offsetY = e.clientY - rect.top;
        var currentPosition = {
            x: position.x,
            y: position.y
        };
        var handleMouseMove = function (e) {
            if (!isFloatingDragging)
                return;
            e.preventDefault();
            e.stopPropagation();
            setTooltipVisible(false);
            currentPosition.x = window.innerWidth - e.clientX - offsetX;
            currentPosition.y = window.innerHeight - e.clientY - offsetY;
            setPosition({
                x: currentPosition.x,
                y: currentPosition.y
            });
        };
        var handleMouseUp = function (e) {
            isFloatingDragging = false;
            setIsDragging(false);
            var closeButton = e.target;
            if (closeButton.closest('.close-button-translator-ekb')) {
                onCloseClick();
            }
            else if (Math.abs(currentPosition.x - position.x) < 5 && Math.abs(currentPosition.y - position.y) < 5) {
                onBubbleClick();
            }
            else {
                setPosition({
                    x: 20,
                    y: currentPosition.y < 0 || currentPosition.y > window.innerHeight - 30 ? 120 : currentPosition.y
                });
            }
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    var onCloseClick = function () {
        var flag = translateConfig.translate.language.translateLocal;
        if (flag) {
            translateConfig.translate.language.translateLocal = false;
            translateConfig.translate.restore();
        }
        localStorage.setItem(Fetch.ekbCorpId + "_enableHyperTranslate", 'close');
        setVisible(false);
        onBubbleClose === null || onBubbleClose === void 0 ? void 0 : onBubbleClose();
    };
    var onBubbleClick = function () {
        var _a, _b;
        setEnable(!enable);
        var flag = translateConfig.translate.language.translateLocal;
        translateConfig.translate.language.translateLocal = !flag;
        if (!flag) {
            translateConfig.translate.ignore.class = ['ignore-translate'];
            (_b = (_a = translateConfig.translate).execute) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else {
            translateConfig.translate.ignore.class.push('translate-ignore-class');
            translateConfig.translate.restore();
        }
    };
    return React.createElement(Tooltip, { title: i18n.get('点击翻译成中文'), placement: 'topRight', open: tooltipVisible, onOpenChange: function (open) { return setTooltipVisible(open); } },
        React.createElement("div", { ref: ref, style: {
                position: 'fixed',
                right: position.x + "px",
                bottom: position.y + "px",
                width: '40px',
                height: '40px',
                borderRadius: '20px',
                transition: 'opacity 0.3s ease',
                opacity: visible ? 1 : 0,
                backgroundColor: 'var(--eui-bg-body)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: "center",
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                cursor: isDragging ? 'grabbing' : 'pointer',
                transform: isDragging ? 'scale(1.1)' : 'none',
                zIndex: 9999,
            }, onMouseDown: handleMouseDown },
            React.createElement("div", { style: {
                    position: 'relative',
                    width: '40px',
                    height: '40px',
                    borderRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: "center",
                } },
                React.createElement(FilledTipsClose, { className: "close-button-translator-ekb", style: {
                        color: "var(--eui-icon-n3)",
                        position: "absolute",
                        top: '-6px',
                        right: '-10px'
                    } }),
                React.createElement(FilledOtherTranslate, { style: {
                        color: "var(--eui-primary-pri-500)",
                        fontSize: 32
                    } }),
                enable && React.createElement(FilledTipsYes, { style: {
                        color: "var(--eui-function-success-500)",
                        position: "absolute",
                        bottom: '2px',
                        right: '2px'
                    } }))));
};
